import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HolidaySummary from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummary";
import { getMaxLuggageCount } from "app/pages/Booking/bookingSelectors";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import get from "lodash/get";
import { OFFER_TYPES } from "app/constants";
import isEmpty from "lodash/isEmpty";
import { getSelectedActivitiesForPriceDetails } from "app/pages/Booking/Quotation/Activity/QuotationActivitySelectors";
import { getNegotiatedOfSelectedOffer } from "app/pages/PrePackage/searchEngineSelectors";
import { isFlashsaleProduct } from "app/utils/utils";
import { getStressMarketingLabel } from "app/pages/StressMarketing/stressMarketingSelector";
import { getQuotationPriceChangeData } from "app/pages/Booking/Quotation/quotationSelectors";

const mapStateToProps = (state, props) => {
	const currentPathname = props.location.pathname;

	const isConfirmationPage = matchPath(
		{
			path: "/booking/confirmation",
		},
		currentPathname
	);

	const isSDPPaymentPage = matchPath(
		{
			path: "/sdp/booking/payment",
		},
		currentPathname
	);

	const isRestoreSessionPage = matchPath(
		{
			path: "/booking/restoreSession",
		},
		currentPathname
	);

	const isPaymentPage = matchPath(
		{
			path: "/booking/payment",
		},
		currentPathname
	);

	const isSDPConfirmationPage = matchPath(
		{
			path: "/sdp/booking/confirmation",
		},
		currentPathname
	);

	const isSDPQuote = matchPath(
		{
			path: "/sdp/booking/quote",
		},
		currentPathname
	);

	const isQuote = matchPath(
		{
			path: "/booking/quote",
		},
		currentPathname
	);

	const isSDP = isSDPQuote || isSDPPaymentPage || isSDPConfirmationPage;
	const partnerCode = state.partner.code;

	const ficheProduit = state.ficheProduit;
	let booking = state.booking || {};

	const stressMarketingMsg = getStressMarketingLabel(booking?.departureDate)(state);

	return {
		isSDP,
		ficheProduit: ficheProduit,
		booking: booking,
		showTimer:
			partnerCode !== "VPDE" && partnerCode !== "PSVP" && isFlashsaleProduct(ficheProduit),
		negotiatedOfSelectedOffer: getNegotiatedOfSelectedOffer(state),
		showFlightDetails:
			(isQuote ||
				isSDPQuote ||
				isRestoreSessionPage ||
				isPaymentPage ||
				isSDPPaymentPage ||
				isConfirmationPage ||
				isSDPConfirmationPage) &&
			get(booking, "offer.type") === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION &&
			!isEmpty(booking.flight),
		luggageMaxCount: getMaxLuggageCount(state),
		quotationStatus: state.quotation?.status,
		activities: getSelectedActivitiesForPriceDetails(state),
		stressMarketingMsg: stressMarketingMsg,
		priceChangeData: getQuotationPriceChangeData(state),
		quotationCode: state.quotation?.code,
		flightOptions: state.quotation?.flightOptions,
		flightOptionsFlightCode: state.quotation?.flightOptionsFlightCode,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(HolidaySummary)
);
